import { isWebhookBodyTemplateInvalid } from "lopermut"
import { FieldPath } from "react-hook-form"
import {
  WebhookBodyFormat,
  WebhookCapabilityConfigBaseSchema,
  WebhookCapabilityConfigSchema,
  WebhookMethod,
} from "schema"
import z from "zod"

export type WebhookConfig = z.infer<typeof WebhookCapabilityConfigSchema>
type WebhookFieldType = WebhookConfig["dataToExtract"][number]["type"]

// Dynamic path — RHF can't verify template literal paths at compile time
export function toFieldPath(namePrefix: string, key: string) {
  return `${namePrefix}${key}` as FieldPath<WebhookConfig>
}

export function getNestedError(errors: unknown, namePrefix: string, key: string) {
  const path = `${namePrefix}${key}`.split(".")
  const found = path.reduce<unknown>((acc, segment) => {
    if (acc && typeof acc === "object") {
      return (acc as Record<string, unknown>)[segment]
    }
    return undefined
  }, errors)
  return (found as { message?: string } | undefined)?.message
}

export function addTypeForHeaderFieldsForm(
  fields: Array<{ name: string; value?: string }> | undefined,
) {
  if (!fields) return []
  return fields.map((field) => ({ ...field, value: field.value ?? "", type: "string" as const }))
}

export function removeTypeFromHeaderFieldsForm(
  fields: Array<{ name: string; value?: string; type: WebhookFieldType }>,
) {
  return fields.map(({ type: _, value, ...rest }) => ({ ...rest, value: value ?? "" }))
}

export function isWebhookRequestInvalid(
  url: string | undefined,
  method: WebhookConfig["method"] | undefined,
  webhookBody: string | undefined | null,
  webhookBodyFormat: keyof typeof WebhookBodyFormat = WebhookBodyFormat.json,
) {
  const urlError = WebhookCapabilityConfigBaseSchema.shape.url.safeParse(url).error
  if (urlError) return true

  return isWebhookBodyTemplateInvalid(webhookBody, webhookBodyFormat, method ?? WebhookMethod.POST)
}
